/**
 * How much of the plan's limits the current workspace uses. Same counting as the server
 * (server/pb_hooks/lib/plans.js): customers, invoices finalised (not draft) and quotes created this
 * calendar month (UTC).
 */
import { pb } from "@/lib/core/pocketbase";
import { currentWorkspaceId } from "./workspaces";

/** First day of the month in PocketBase's date format, like monthStart() in the hook library. */
export function monthStart(now = new Date()): string {
  const month = String(now.getUTCMonth() + 1).padStart(2, "0");
  return `${now.getUTCFullYear()}-${month}-01 00:00:00.000Z`;
}

async function count(collection: "customers" | "invoices", filter: string) {
  const page = await pb.collection(collection).getList(1, 1, { filter, fields: "id" });
  return page.totalItems;
}

export function countCustomers(): Promise<number> {
  return count("customers", pb.filter("workspace = {:w}", { w: currentWorkspaceId() }));
}

export function countFinalisedInvoicesThisMonth(now = new Date()): Promise<number> {
  return count(
    "invoices",
    pb.filter(
      'workspace = {:w} && abstractType = "invoice" && creditFor = "" && finalizedAt >= {:start}',
      { w: currentWorkspaceId(), start: monthStart(now) },
    ),
  );
}

/** Quotes created this month, finalised or not (the Free plan's monthly quote limit). */
export function countQuotesThisMonth(now = new Date()): Promise<number> {
  return count(
    "invoices",
    pb.filter('workspace = {:w} && abstractType = "quote" && created >= {:start}', {
      w: currentWorkspaceId(),
      start: monthStart(now),
    }),
  );
}
